// breakpoints
export const lowBP = 768;
export const mediumBP = 1024;
export const largeBP = 1250;

// general layout
export const desktopHeaderHeight = 100;
export const desktopTopSectionMargin = 60;

export const tabletHeaderHeight = 70;
export const tabletTopSectionMargin = 45;

export const mobileHeaderHeight = 70;
export const mobileTopSectionMargin = 0;

// top section height
export const desktopTopSectionHeight = `calc(100vh - ${desktopTopSectionMargin + desktopHeaderHeight}px)`;
export const tabletTopSectionHeight = `calc(100vh - ${tabletTopSectionMargin + tabletHeaderHeight}px)`;
export const mobileTopSectionHeight = `calc(100vh - ${mobileTopSectionMargin + mobileHeaderHeight}px)`;
